function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-edit",
    d: "M4.5 23.5v5h5l14.744-14.748-5-5zM28.11 9.886a1.328 1.328 0 0 0 0-1.88l-3.12-3.12a1.328 1.328 0 0 0-1.88 0l-2.44 2.44 5 5 2.44-2.44z",
    transform: "translate(-4.5 -4.496)",
    style: {
      fill: "#204bf8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.56d3a6d11ede24412863ed26408a6e7e.svg";
export { ForwardRef as ReactComponent };